import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { RecommendedPortfolioAssetItem } from '../../../../../../../../../../store/customerAssetDetail/types';

import { PortfolioAssetItemDesktop } from './desktop';
import { PortfolioAssetItemMobile } from './mobile';

export interface PortfolioAssetItemProps {
  asset: RecommendedPortfolioAssetItem;
}

export const PortfolioAssetItem: React.FC<PortfolioAssetItemProps> = ({ asset }) => {
  const portfolioAssetItem = useBreakpointValue({
    base: <PortfolioAssetItemMobile asset={asset} />,
    sm: <PortfolioAssetItemMobile asset={asset} />,
    lg: <PortfolioAssetItemDesktop asset={asset} />,
  });

  return portfolioAssetItem;
};
